import { Modal } from "antd";
import { pipViewDate2 } from "../../../../utils/pip";

const AdminTicketDetails = ({ isModal, setIsModal, ticket }) => {
  if (!ticket) return null;

  const normalizeImages = (value) => {
    if (Array.isArray(value)) return value.filter(Boolean);
    if (!value) return [];
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (!trimmed) return [];
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) return parsed.filter(Boolean);
      } catch (_) {}
      return trimmed
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);
    }
    return [];
  };

  const images = normalizeImages(ticket?.images);
  const profileImage =
    ticket?.ticket_user_profile_image || "/assets/img/user_profile.png";
  const fullName =
    ticket?.ticket_user_full_name ||
    `${ticket?.ticket_user_first_name || ""} ${
      ticket?.ticket_user_last_name || ""
    }`.trim() ||
    "#N/A";

  return (
    <Modal
      className=""
      visible={isModal}
      onCancel={() => setIsModal(false)}
      centered
      footer={null}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body px-4 pb-5">
            <div className="d-flex align-items-start justify-content-between mb-3">
              <div>
                <h4 className="mb-1 ct_fs_20">Support Ticket Details</h4>
                <p className="mb-0 ct_grey_text">
                  Review ticket and user information
                </p>
              </div>
            </div>

            <div className="d-flex align-items-center gap-3 mb-3">
              <img src={profileImage} className="ct_img_56" />
              <div>
                <h5 className="ct_fs_18 ct_fw_600 mb-1">{fullName}</h5>
                <p className="mb-0 ct_grey_text ct_fs_14">
                  {ticket?.ticket_user_email || "#N/A"}
                </p>
                <p className="mb-0 ct_grey_text ct_fs_12 text-uppercase">
                  {ticket?.ticket_user_role || ""}
                </p>
              </div>
            </div>

            <ul className="list-unstyled">
              <li className="mb-2">
                <strong className="ct_fw_600">Title:</strong>{" "}
                <span>{ticket?.title || "#N/A"}</span>
              </li>
              <li className="mb-2">
                <strong className="ct_fw_600">Category:</strong>{" "}
                <span>{ticket?.category || "#N/A"}</span>
              </li>
              <li className="mb-2">
                <strong className="ct_fw_600">Status:</strong>{" "}
                <span className="text-capitalize">
                  {ticket?.status || "#N/A"}
                </span>
              </li>
              <li className="mb-2">
                <strong className="ct_fw_600">Created At:</strong>{" "}
                <span>
                  {ticket?.created_at
                    ? pipViewDate2(ticket?.created_at)
                    : "#N/A"}
                </span>
              </li>
              {ticket?.ticket_user_phone_number && (
                <li className="mb-2">
                  <strong className="ct_fw_600">Phone:</strong>{" "}
                  <span>{ticket?.ticket_user_phone_number}</span>
                </li>
              )}
            </ul>

            {ticket?.description && (
              <div className="mt-3">
                <p className="ct_fs_16 mb-1">Description</p>
                <p className="mb-0 ct_fs_14 ct_para_scroll ct_custom_scroll">
                  {ticket?.description}
                </p>
              </div>
            )}

            {images.length > 0 && (
              <div className="mt-3">
                <p className="ct_fs_16 mb-1">Attachments</p>
                <div className="ct_multiple_img_div ct_custom_scroll d-flex gap-3 mt-3">
                  {images.map((img, idx) => (
                    <div
                      className="position-relative ct_iframe_hover"
                      style={{ width: "120px", height: "120px" }}
                      key={`${img}-${idx}`}
                    >
                      <div className="ct_document_uploaded_img">
                        <img
                          src={img}
                          alt=""
                          style={{
                            width: "120px",
                            height: "120px",
                            objectFit: "cover",
                            borderRadius: "10px",
                          }}
                        />
                      </div>
                      <a href={img} target="_blank" className="ct_pdf_full_view">
                        <i className="fa-solid fa-eye ct_cursor_pointer text-white"></i>
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AdminTicketDetails;
